import { network } from 'services/network';

import { QueryResponse } from 'api/endPoints/getScheduleQualityScore/types';

export const ENDPOINT = 'api/bo/getScheduleQualityScore';

export const getScheduleQualityScore = (params) => {
    return network.post<QueryResponse>(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
